module.exports = __webpack_public_path__ + "static/media/Pulmonology-Epworth Sleepiness Scale-2@3x.af8cec2a.png";